<template>
  <section id="process" class="process">
    <div class="shell process-grid">
      <div>
        <header v-reveal class="process-head">
          <h2>How a project works</h2>
          <p>
            You work with me from the first conversation to the final details. I
            show you progress early, so we can get it right together.
          </p>
        </header>
        <ol class="steps">
          <li
            v-for="(step, i) in steps"
            :key="step.title"
            v-reveal
            class="step"
            :style="{ transitionDelay: `${i * 70}ms` }"
          >
            <span class="step-num" aria-hidden="true">{{ i + 1 }}</span>
            <div>
              <h3>{{ step.title }}</h3>
              <p>{{ step.body }}</p>
            </div>
          </li>
        </ol>
      </div>
      <div v-reveal class="process-photo">
        <img
          src="/photos/process.webp"
          srcset="/photos/process.webp 1200w, /photos/process-1800.webp 1800w"
          sizes="(max-width: 900px) calc(100vw - 40px), 800px"
          alt=""
          width="1200"
          height="800"
          loading="lazy"
          decoding="async"
          @error="$event.target.hidden = true"
        />
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "ProcessSection",
  data: () => ({
    steps: [
      {
        title: "Talk it through",
        body: "Tell me what you’re working on, what’s getting in the way, and what a better day looks like.",
      },
      {
        title: "Agree a clear plan",
        body: "We agree on the scope, priorities, price and timeline before the build begins.",
      },
      {
        title: "Build, show, refine",
        body: "You see the work as it takes shape. We test it together and adjust the details.",
      },
      {
        title: "Launch",
        body: "I walk you through your new tools, and we agree on any support you need next.",
      },
    ],
  }),
};
</script>
